import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {LoginComponent} from "./auth/login/login.component";
import {LogoutComponent} from "./auth/logout/logout.component";
import {ForgotPasswordComponent} from "./obligor-search/change-password-modal/forgot-password.component";
import {RecoverPasswordComponent} from "./auth/recover-password/recover-password.component";
import {CachedFilesComponent} from "./obligor-search/cached-files/cached-files.component";
import {AuthGuard} from "./auth/auth.guard";
import {AuthGuardPowerUser} from "./auth/auth-power-user.guard";
import {NewsComponent} from "./news/news.component";
import {NotFoundRecourseComponent} from "./not-found-recource/not-found-recourse.component";
import {DirectDocMGNComponent} from "./direct-doc/direct-doc-mgn.component";


const routes: Routes = [
  {
    path: 'login',
    component: LoginComponent
  },
  {
    path: 'logout',
    component: LogoutComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'forgotPassword',
    component: ForgotPasswordComponent,

  },
  {
    path: 'recoverPassword',
    component: RecoverPasswordComponent
  },
  {
    path: 'cached-files',
    component: CachedFilesComponent,
    canActivate: [AuthGuardPowerUser]
  },
  {
    path: '',
    loadChildren: () => import('./obligor-search/obligor-search.module').then(m => m.ObligorSearchModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'pro-report',
    loadChildren: () => import('./pro-report/pro-report.module').then(m => m.ProReportModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'doc-mgn/:storyId',
    component: NewsComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'doc-pdf/:docId',
    component: NotFoundRecourseComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'direct-doc-mgn',
    component: DirectDocMGNComponent
  },
  {
    path: 'FilingsSummary/obligor-da',
    loadChildren: () => import('./direct-access/direct-access.module').then(m => m.DirectAccessModule)
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
